import type {SortingOption} from '@/modules/common/context/QueryParams/models';

import {useTranslation} from 'react-i18next';

import {config} from '@/config';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

type SortingDropdownItem = {
  label: string;
  value: SortingOption;
  hint: string;
  description: string;
};

export const useSortingOptions = (): Array<SortingDropdownItem> => {
  const {t} = useTranslation('general');
  const currentPage = useCurrentPage();

  return config.sorting.optionsByPage[currentPage].map((value) => ({
    value,
    label: t(`sortingDropdown.options.${value}.label`),
    hint: t(`sortingDropdown.options.${value}.hint`, {defaultValue: ''}),
    description: t(`sortingDropdown.options.${value}.description`, {
      defaultValue: '',
    }),
  }));
};
